// extracted by mini-css-extract-plugin
export default {"form_items":"style_form_items__Y7ibB","form_notes":"style_form_notes__Nt-N3"};